import type { WUserAccountTranslations } from "./pl";

export const en: WUserAccountTranslations = {
  loginButton: "Sign in",
  greeting: "Hi, {name}",
  defaultGreetingName: "User",

  modalTitle: "Sign in",
  modalClose: "Close",

  loginLabel: "Login or email",
  passwordLabel: "Password",
  submitLogin: "Sign in",
  submitLoginBusy: "Signing in…",
  registerLink: "Create account",
  forgotPasswordLink: "Forgot password",

  validationLoginRequired: "Enter login or email address.",
  validationPasswordRequired: "Enter password.",

  loginFailed: "Sign-in failed.",
  networkError: "Network error.",

  myAccountLink: "My account",
  logoutAction: "Sign out",
  logoutFailed: "Failed to sign out.",

  errorNotLinked: "Widget is not linked to a user accounts catalog. Contact the administrator.",
  errorCatalogMissing: "Linked user accounts catalog does not exist. Contact the administrator.",
  errorFetchFailed: "Failed to load account widget.",
};
